// load the slick-carousel lib
require('slick-carousel');

/**
 * create the carousel object for the given jQuery wrapped DOM el.
 * @param $el
 * @param opts {Object} having the following config options
 * - speed: {Integer} the speed to scroll by when scrolling
 * - pageSize: {Integer} the number of carousel items to show on a page.
 *
 */
let carousel = ($el, opts) => {
    opts = opts || {};

    let defaults = {
        speed: 300,
        pageSize: 3,
        filter: null
    };

    let options = $.extend({}, defaults, opts);

    $el.slick({
        dots: true,
        infinite: true,
        speed: options.speed,
        slidesToShow: options.pageSize,
        slidesToScroll: options.pageSize
    });

    if (options.filter) {
        $el.slick('slickFilter', options.filter);
    }
};

module.exports = carousel;


// WEBPACK FOOTER //
// ./assets/js/app/lib/carousel.js